// The groups a settings screen is divided into (spec/13 §13, spec/14 §14; F-ORG-02).
//
// "Settings screens are generated from the registry": a console renders one heading per group, in
// this order, and under it every setting whose `group` names it — its value, where the value comes
// from, a reset to inherited, its description, and a control generated from its schema. So a
// setting says which group it belongs to, and a new setting is a registry entry and nothing else:
// no screen, no route, no switch in a component.
//
// The first seventeen are the venue groups of spec/13 §13, in that table's order. The last three
// are the organisation's and HQ's own, which spec/13 §13 does not list because it describes the
// venue screen. `offlinePlay` (2026-10-01, the owner's offline-play decision) sits after Sessions: what a
// station does when it cannot reach the cloud — keep running sessions going, staff codes, known players,
// strict lock (spec/05 §8.1). `daysAndShifts` (2026-10-01, ADR-0029) sits after Payments: how the venue's business
// day ends — closed by staff, or rolled over at the cutoff by itself (24×7 venues) — and whether drawers are counted
// per shift. `counters` (2026-10-02, ADR-0032) follows it: the venue's list of counters a shift starts at, with its own
// endpoints. `boot` (2026-10-14, ADR-0063) follows the seventeen: the venue's Clavian Boot settings (spec/25 §14), shown
// only to an organisation with the `boot` add-on. The last three:
//
//   staff           who must use a second factor, how long a counter PIN session lasts
//                   (`staff.require2faRoles`, `staff.pinSessionMinutes`) — spec/13 §15's "Staff and
//                   roles" area
//   dataRetention   how long records are kept (`audit.retentionYears`) — HQ's
//   featureFlags    the `flags.*` release controls (`defineFeatureFlag`) — HQ's platform settings
//                   screen lists them (F-HQ-38)
//
// The titles are the headings as spec/13 §13 writes them. They live beside the ids, as a setting's
// description lives beside its key, because both are what the registry says about the screen it
// generates.
/** Every group, in the order a settings screen shows them. */
export const SETTING_GROUP_IDS = [
    'venueProfile',
    'kiosk',
    'sessions',
    'offlinePlay',
    'stationsAndLocker',
    'pricing',
    'payments',
    'daysAndShifts',
    'counters',
    'taxAndInvoices',
    'foodAndDrinks',
    'reservations',
    'loyalty',
    'players',
    'printersAndHardware',
    'notifications',
    'integrations',
    'boot',
    'staff',
    'dataRetention',
    'featureFlags',
];
/** Each group's heading. */
export const SETTING_GROUP_TITLES = {
    venueProfile: 'Venue profile',
    kiosk: 'Kiosk',
    sessions: 'Sessions',
    offlinePlay: 'Offline play',
    stationsAndLocker: 'Stations and locker',
    pricing: 'Pricing',
    payments: 'Payments',
    daysAndShifts: 'Days and shifts',
    counters: 'Counters',
    taxAndInvoices: 'Tax and invoices',
    foodAndDrinks: 'Food and drinks',
    reservations: 'Reservations and waitlist',
    loyalty: 'Loyalty',
    players: 'Players',
    printersAndHardware: 'Printers and hardware',
    boot: 'Clavian Boot',
    notifications: 'Notifications',
    integrations: 'Integrations',
    staff: 'Staff and roles',
    dataRetention: 'Data retention',
    featureFlags: 'Feature flags',
};
export function isSettingGroup(value) {
    return typeof value === 'string' && SETTING_GROUP_IDS.includes(value);
}
//# sourceMappingURL=groups.js.map